// Adapted from the coolname Python project: https://github.com/alexanderlukanin13/coolname

export const adjectives = [
  'acrid',
  'ambrosial',
  'amorphous',
  'armored',
  'aromatic',
  'bald',
  'blazing',
  'boisterous',
  'bouncy',
  'brawny',
  'bulky',
  'camouflaged',
  'caped',
  'elastic',
  'ethereal',
  'feathered',
  'fiery',
  'fluffy',
  'foamy',
  'fragrant',
  'furry',
  'fuzzy',
  'glaring',
  'hairy',
  'heavy',
  'hissing',
  'horned',
  'icy',
  'imaginary',
  'invisible',
  'lean',
  'loud',
  'loutish',
  'lumpy',
  'lush',
  'masked',
  'meaty',
  'messy',
  'misty',
  'nebulous',
  'noisy',
  'nondescript',
  'organic',
  'purring',
  'quiet',
  'quirky',
  'radiant',
  'roaring',
  'ruddy',
  'rustling',
  'screeching',
  'shaggy',
  'shapeless',
  'shiny',
  'silent',
  'silky',
  'singing',
  'skinny',
  'smooth',
  'soft',
  'spicy',
  'spiked',
  'statuesque',
  'sticky',
  'tacky',
  'tall',
  'tangible',
  'tentacled',
  'thundering',
  'venomous',
  'warm',
  'weightless',
  'whispering',
  'winged',
  'wooden',
  'adorable',
  'affable',
  'amazing',
  'amiable',
  'attractive',
  'beautiful',
  'calm',
  'charming',
  'cherubic',
  'classic',
  'classy',
  'convivial',
  'cordial',
  'cuddly',
  'curly',
  'cute',
  'debonair',
  'elegant',
  'famous',
  'fresh',
  'friendly',
  'funny',
  'gorgeous',
  'graceful',
  'gregarious',
  'grinning',
  'handsome',
  'hilarious',
  'hot',
  'interesting',
  'kind',
  'laughing',
  'lovely',
  'meek',
  'mellow',
  'merciful',
  'neat',
  'nifty',
  'notorious',
  'poetic',
  'pretty',
  'refined',
  'refreshing',
  'smiling',
  'sociable',
  'spiffy',
  'stylish',
  'sweet',
  'tactful',
  'whimsical',
  'abiding',
  'accurate',
  'adamant',
  'adaptable',
  'adventurous',
  'alluring',
  'aloof',
  'ambitious',
  'amusing',
  'annoying',
  'arrogant',
  'aspiring',
  'belligerent',
  'benign',
  'berserk',
  'benevolent',
  'bold',
  'brave',
  'cheerful',
  'chirpy',
  'cocky',
  'congenial',
  'courageous',
  'cryptic',
  'curious',
  'daft',
  'dainty',
  'daring',
  'defiant',
  'delicate',
  'delightful',
  'determined',
  'devout',
  'didactic',
  'diligent',
  'discreet',
  'dramatic',
  'dynamic',
  'eager',
  'eccentric',
  'elated',
  'encouraging',
  'enigmatic',
  'enthusiastic',
  'evasive',
  'faithful',
  'fair',
  'fanatic',
  'fearless',
  'fervent',
  'festive',
  'fierce',
  'fine',
  'free',
  'gabby',
  'garrulous',
  'gentle',
  'glistening',
  'greedy',
  'grumpy',
  'happy',
  'honest',
  'hopeful',
  'hospitable',
  'impetuous',
  'independent',
  'industrious',
  'innocent',
  'intrepid',
  'jolly',
  'jovial',
  'just',
  'lively',
  'loose',
  'loyal',
  'merry',
  'modest',
  'mysterious',
  'nice',
  'obedient',
  'optimistic',
  'orthodox',
  'outgoing',
  'outrageous',
  'overjoyed',
  'passionate',
  'perky',
  'placid',
  'polite',
  'positive',
  'proud',
  'prudent',
  'puzzling',
  'quixotic',
  'quizzical',
  'rebel',
  'resolute',
  'rampant',
  'righteous',
  'romantic',
  'rough',
  'rousing',
  'sassy',
  'satisfied',
  'sly',
  'sincere',
  'snobbish',
  'spirited',
  'spry',
  'stalwart',
  'stirring',
  'swinging',
  'tasteful',
  'thankful',
  'tidy',
  'tremendous',
  'truthful',
  'unselfish',
  'upbeat',
  'uppish',
  'valiant',
  'vehement',
  'vengeful',
  'vigorous',
  'vivacious',
  'zealous',
  'zippy',
  'able',
  'adept',
  'analytic',
  'astute',
  'attentive',
  'brainy',
  'busy',
  'calculating',
  'capable',
  'careful',
  'cautious',
  'certain',
  'clever',
  'competent',
  'conscious',
  'cooperative',
  'crafty',
  'crazy',
  'cunning',
  'daffy',
  'devious',
  'discerning',
  'efficient',
  'expert',
  'functional',
  'gifted',
  'helpful',
  'enlightened',
  'idealistic',
  'impartial',
  'industrious',
  'ingenious',
  'inquisitive',
  'intelligent',
  'inventive',
  'judicious',
  'keen',
  'knowing',
  'literate',
  'logical',
  'masterful',
  'mindful',
  'nonchalant',
  'observant',
  'omniscient',
  'poised',
  'practical',
  'pragmatic',
  'proficient',
  'provocative',
  'qualified',
  'radical',
  'rational',
  'realistic',
  'resourceful',
  'savvy',
  'skeptical',
  'sensible',
  'serious',
  'shrewd',
  'skilled',
  'slick',
  'slim',
  'smart',
  'sophisticated',
  'stoic',
  'succinct',
  'talented',
  'thoughtful',
  'tricky',
  'unbiased',
  'uptight',
  'versatile',
  'versed',
  'visionary',
  'wise',
  'witty',
  'accelerated',
  'active',
  'agile',
  'athletic',
  'dashing',
  'deft',
  'dexterous',
  'energetic',
  'fast',
  'frisky',
  'hasty',
  'hypersonic',
  'meteoric',
  'mighty',
  'muscular',
  'nimble',
  'powerful',
  'prompt',
  'quick',
  'rapid',
  'resilient',
  'robust',
  'rugged',
  'solid',
  'speedy',
  'steadfast',
  'steady',
  'strong',
  'sturdy',
  'tireless',
  'tough',
  'unyielding',
  'rich',
  'wealthy',
  'meticulous',
  'precise',
  'rigorous',
  'scrupulous',
  'strict',
  'airborne',
  'burrowing',
  'crouching',
  'flying',
  'hidden',
  'hopping',
  'jumping',
  'lurking',
  'tunneling',
  'warping',
  'aboriginal',
  'amphibian',
  'aquatic',
  'arboreal',
  'polar',
  'terrestrial',
  'urban',
  'accomplished',
  'astonishing',
  'authentic',
  'awesome',
  'delectable',
  'excellent',
  'exotic',
  'exuberant',
  'fabulous',
  'fantastic',
  'fascinating',
  'flawless',
  'fortunate',
  'glorious',
  'groovy',
  'honored',
  'illustrious',
  'imposing',
  'important',
  'impressive',
  'incredible',
  'invaluable',
  'majestic',
  'magnificent',
  'marvellous',
  'monumental',
  'perfect',
  'phenomenal',
  'pompous',
  'precious',
  'premium',
  'private',
  'remarkable',
  'spectacular',
  'splendid',
  'successful',
  'wonderful',
  'wondrous',
  'offbeat',
  'original',
  'outstanding',
  'quaint',
  'unique',
  'ancient',
  'antique',
  'prehistoric',
  'primitive',
  'abstract',
  'acoustic',
  'angelic',
  'arcane',
  'archetypal',
  'augmented',
  'auspicious',
  'axiomatic',
  'beneficial',
  'bipedal',
  'bizarre',
  'complex',
  'dancing',
  'dangerous',
  'divergent',
  'economic',
  'electric',
  'elite',
  'eminent',
  'enchanted',
  'esoteric',
  'finicky',
  'fractal',
  'futuristic',
  'gainful',
  'hallowed',
  'heavenly',
  'holistic',
  'hungry',
  'hypnotic',
  'hysterical',
  'illegal',
  'imperial',
  'imported',
  'impossible',
  'inescapable',
  'liberal',
  'ludicrous',
  'lyrical',
  'magnetic',
  'manipulative',
  'mature',
  'military',
  'macho',
  'married',
  'melodic',
  'natural',
  'naughty',
  'nocturnal',
  'nostalgic',
  'optimal',
  'pastoral',
  'peculiar',
  'piquant',
  'pristine',
  'prophetic',
  'psychedelic',
  'quantum',
  'rare',
  'real',
  'secret',
  'simple',
  'spectral',
  'spiritual',
  'stereotyped',
  'stimulating',
  'straight',
  'strange',
  'tested',
  'therapeutic',
  'true',
  'ubiquitous',
  'uncovered',
  'unnatural',
  'utopian',
  'vagabond',
  'vague',
  'vegan',
  'victorious',
  'vigilant',
  'voracious',
  'wakeful',
  'wandering',
  'watchful',
  'wild',
  'bright',
  'brilliant',
  'colorful',
  'crystal',
  'dark',
  'dazzling',
  'fluorescent',
  'glittering',
  'glossy',
  'gleaming',
  'light',
  'mottled',
  'neon',
  'opalescent',
  'pastel',
  'smoky',
  'sparkling',
  'spotted',
  'striped',
  'translucent',
  'transparent',
  'vivid'
]
